/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал взаимодействия с внешними партнёрами IoT
 */

/**
 * Сервис для взаимодействия с внешними партнёрами Iot
 */
export class IotConnectCallbackServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения пользователя.
   * Метод доступен для: TokenACF: Scope: iot
   */
  GetCallbackUser = (req?: GetCallbackUserRequestDto, init?: RequestInit): Promise<GetCallbackUserResponseDto> => {
    return fm.request<GetCallbackUserRequestDto, GetCallbackUserResponseDto>(`${this.host}/iot_connect/api/v1/callback/user${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения устройств, доступных пользователю.
   * Метод доступен для: TokenACF: Scope: iot
   */
  GetCallbackDevices = (req?: GetCallbackDevicesRequestDto, init?: RequestInit): Promise<GetCallbackDevicesResponseDto> => {
    return fm.request<GetCallbackDevicesRequestDto, GetCallbackDevicesResponseDto>(`${this.host}/iot_connect/api/v1/callback/devices${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения внешним партнёром состояния устройства.
   * Метод доступен для: TokenACF: Scope: iot
   */
  PostCallbackStatus = (req?: PostCallbackStatusRequestDto, init?: RequestInit): Promise<PostCallbackStatusResponseDto> => {
    return fm.request<PostCallbackStatusRequestDto, PostCallbackStatusResponseDto>(`${this.host}/iot_connect/api/v1/callback/status`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод запроса внешнего IoT партнёра на изменение состояния устройства.
   * Поддерживается только открытие домофона.
   * Метод доступен для: TokenACF: Scope: iot
   */
  PostCallbackCommand = (req?: PostCallbackCommandRequestDto, init?: RequestInit): Promise<PostCallbackCommandResponseDto> => {
    return fm.request<PostCallbackCommandRequestDto, PostCallbackCommandResponseDto>(`${this.host}/iot_connect/api/v1/callback/command`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сообщения от внешнего IoT партнёра о разъединении аккаунтов.
   * Метод доступен для: TokenACF: Scope: iot
   */
  PostCallbackUnlink = (req?: PostCallbackUnlinkRequestDto, init?: RequestInit): Promise<PostCallbackUnlinkResponseDto> => {
    return fm.request<PostCallbackUnlinkRequestDto, PostCallbackUnlinkResponseDto>(`${this.host}/iot_connect/api/v1/callback/unlink`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Сообщение ошибки на запрос
 */
export type CommonErrorRequestDto = {
  /**
   * Коммент 1
   */
  code?: number
  /**
   * Коммент 1
   */
  message?: string
  /**
   * Коммент 1
   */
  details?: string
}
/**
 * Сообщение ошибки на запрос
 */
export type CommonErrorResponseDto = {
  /**
   * Коммент 1
   */
  code: number
  /**
   * Коммент 1
   */
  message: string
  /**
   * Коммент 1
   */
  details: string
}
/**
 * Объект устройства
 */
export type DeviceRequestDto = {
  /**
   * Идентификатор пользователя
   */
  userId?: number
  /**
   * Коммент 1
   */
  id?: string
  /**
   * Коммент 1
   */
  parentId?: string
  /**
   * Коммент 1
   */
  name?: string
  /**
   * Коммент 1
   */
  defaultName?: string
  /**
   * Коммент 1
   */
  home?: string
  /**
   * Коммент 1
   */
  room?: string
  /**
   * Коммент 1
   */
  groups?: string[]
  /**
   * Коммент 1
   */
  modelId?: string
  /**
   * Коммент 1
   */
  hwVersion?: string
  /**
   * Коммент 1
   */
  swVersion?: string
}
/**
 * Объект устройства
 */
export type DeviceResponseDto = {
  /**
   * Идентификатор пользователя
   */
  userId: number
  /**
   * Коммент 1
   */
  id: string
  /**
   * Коммент 1
   */
  parentId: string
  /**
   * Коммент 1
   */
  name: string
  /**
   * Коммент 1
   */
  defaultName: string
  /**
   * Коммент 1
   */
  home: string
  /**
   * Коммент 1
   */
  room: string
  /**
   * Коммент 1
   */
  groups: string[]
  /**
   * Коммент 1
   */
  modelId: string
  /**
   * Коммент 1
   */
  hwVersion: string
  /**
   * Коммент 1
   */
  swVersion: string
}
/**
 * Запрос списка домофонов пользователя в виде связки квартира-домофон, к которым имеет доступ пользователь
 */
export type GetCallbackDevicesRequestDto = {
}
/**
 * Ответ на запрос списка домофонов пользователя в виде связки квартира-домофон, к которым имеет доступ пользователь
 */
export type GetCallbackDevicesResponseDto = {
  /**
   * Массив домофонов пользователя
   */
  data: DeviceResponseDto[]
}
/**
 * Запрос идентификатора пользователя Ключ
 */
export type GetCallbackUserRequestDto = {
}
/**
 * Ответ на запрос идентификатора пользователя Ключ
 */
export type GetCallbackUserResponseDto = {
  /**
   * Идентификатор пользователя
   */
  data: number
}
/**
 * Запрос на изменение статуса домофона
 */
export type PostCallbackCommandRequestDto = {
}
/**
 * Ответ на запрос на изменение статуса домофона
 */
export type PostCallbackCommandResponseDto = {
}
/**
 * Запрос статуса домофонов пользователя
 */
export type PostCallbackStatusRequestDto = {
  /**
   * Массив домофонов пользователя
   */
  data?: string[]
}
/**
 * Ответ на запрос статуса домофонов пользователя
 */
export type PostCallbackStatusResponseDto = {
  /**
   * Коммент
   */
  data: PostCallbackStatusResponseStatusDto | null
}
/**
 * Коммент 1
 */
export type PostCallbackStatusResponseStatusDto = {
  /**
   * Идентификатор пользователя
   */
  userId: number
  /**
   * Коммент 1
   */
  id: string
  /**
   * Коммент 1
   */
  parentId: string
  /**
   * Коммент 1
   */
  name: string
  /**
   * Коммент 1
   */
  defaultName: string
  /**
   * Коммент 1
   */
  home: string
  /**
   * Коммент 1
   */
  room: string
  /**
   * Коммент 1
   */
  groups: string[]
  /**
   * Коммент 1
   */
  modelId: string
  /**
   * Коммент 1
   */
  hwVersion: string
  /**
   * Коммент 1
   */
  swVersion: string
}
/**
 * Запрос-информирование о разъединении аккаунтов
 */
export type PostCallbackUnlinkRequestDto = {
}
/**
 * Ответ на запрос-информирование о разъединении аккаунтов
 */
export type PostCallbackUnlinkResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Сообщение ошибки на запрос
   */
  "CommonError": {
    "kind": "class",
    "text": "Сообщение ошибки на запрос",
    "fields": {
      /**
       * Коммент 1
       */
      "code": {
        "type": "int32",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "message": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "details": {
        "type": "string",
        "text": "Коммент 1",
      },
    },
  },
  /**
   * Объект устройства
   */
  "Device": {
    "kind": "class",
    "text": "Объект устройства",
    "fields": {
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
      },
      /**
       * Коммент 1
       */
      "id": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "parentId": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "name": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "defaultName": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "home": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "room": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "groups": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "modelId": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "hwVersion": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "swVersion": {
        "type": "string",
        "text": "Коммент 1",
      },
    },
  },
  /**
   * Запрос списка домофонов пользователя в виде связки квартира-домофон, к которым имеет доступ пользователь
   */
  "GetCallbackDevicesRequest": {
    "kind": "class",
    "text": "Запрос списка домофонов пользователя в виде связки квартира-домофон, к которым имеет доступ пользователь",
  },
  /**
   * Ответ на запрос списка домофонов пользователя в виде связки квартира-домофон, к которым имеет доступ пользователь
   */
  "GetCallbackDevicesResponse": {
    "kind": "class",
    "text": "Ответ на запрос списка домофонов пользователя в виде связки квартира-домофон, к которым имеет доступ пользователь",
    "fields": {
      /**
       * Массив домофонов пользователя
       */
      "data": {
        "type": "Device",
        "text": "Массив домофонов пользователя",
      },
    },
  },
  /**
   * Запрос идентификатора пользователя Ключ
   */
  "GetCallbackUserRequest": {
    "kind": "class",
    "text": "Запрос идентификатора пользователя Ключ",
  },
  /**
   * Ответ на запрос идентификатора пользователя Ключ
   */
  "GetCallbackUserResponse": {
    "kind": "class",
    "text": "Ответ на запрос идентификатора пользователя Ключ",
    "fields": {
      /**
       * Идентификатор пользователя
       */
      "data": {
        "type": "int32",
        "text": "Идентификатор пользователя",
      },
    },
  },
  /**
   * Запрос на изменение статуса домофона
   */
  "PostCallbackCommandRequest": {
    "kind": "class",
    "text": "Запрос на изменение статуса домофона",
  },
  /**
   * Ответ на запрос на изменение статуса домофона
   */
  "PostCallbackCommandResponse": {
    "kind": "class",
    "text": "Ответ на запрос на изменение статуса домофона",
  },
  /**
   * Запрос статуса домофонов пользователя
   */
  "PostCallbackStatusRequest": {
    "kind": "class",
    "text": "Запрос статуса домофонов пользователя",
    "fields": {
      /**
       * Массив домофонов пользователя
       */
      "data": {
        "type": "string",
        "text": "Массив домофонов пользователя",
      },
    },
  },
  /**
   * Ответ на запрос статуса домофонов пользователя
   */
  "PostCallbackStatusResponse": {
    "kind": "class",
    "text": "Ответ на запрос статуса домофонов пользователя",
    "fields": {
      /**
       * Коммент
       */
      "data": {
        "type": "PostCallbackStatusResponse.Status",
        "text": "Коммент",
      },
    },
  },
  /**
   * Коммент 1
   */
  "PostCallbackStatusResponse.Status": {
    "kind": "class",
    "text": "Коммент 1",
    "fields": {
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
      },
      /**
       * Коммент 1
       */
      "id": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "parentId": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "name": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "defaultName": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "home": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "room": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "groups": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "modelId": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "hwVersion": {
        "type": "string",
        "text": "Коммент 1",
      },
      /**
       * Коммент 1
       */
      "swVersion": {
        "type": "string",
        "text": "Коммент 1",
      },
    },
  },
  /**
   * Запрос-информирование о разъединении аккаунтов
   */
  "PostCallbackUnlinkRequest": {
    "kind": "class",
    "text": "Запрос-информирование о разъединении аккаунтов",
  },
  /**
   * Ответ на запрос-информирование о разъединении аккаунтов
   */
  "PostCallbackUnlinkResponse": {
    "kind": "class",
    "text": "Ответ на запрос-информирование о разъединении аккаунтов",
  },
}